import React, { useState, useCallback } from "react";
import styles from "./ProductPoll.module.css";
import NavPanel from "../components/NavPanel";
import ProgressBar from "../components/ProgressBar";
import { useNavigate } from "react-router-dom";
import NBLogo from "../components/NBLogo";


const ProductPoll = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(4)
  const [delrayGrow, setDelrayGrow] = useState(false);
  const [rallyGrow, setRallyGrow] = useState(false);

  const sleep = ms => new Promise(r => setTimeout(r, ms));
  
  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate('/delray');
  }, [navigate]);

  const onClickDelray = useCallback(async () => {
    setStep(5);
    setDelrayGrow(true);
    await sleep(1100);
    navigate('/delray');
  }, [navigate])

  const onClickRally = useCallback(async () => {
    setStep(5);
     setRallyGrow(true);
    await sleep(1100);
    navigate('/rally');
  }, [navigate])

  return (
    <div className={styles.productPoll}>
      <ProgressBar current={step} />
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel postion='right' onClick={onNextPageClick} />
      <div className={styles.question}>
        <NBLogo/>
        <div className={ `${styles.caption} ${delrayGrow || rallyGrow ? styles.rallyHiding : ''}` }>
          Which best fits your game?
        </div>
      </div>

      <div className={styles.cards}>
        <div className={ `${styles.card} ${delrayGrow ? styles.delrayMoving : ''} ${rallyGrow ? styles.delrayHiding : ''}`  } onClick={onClickDelray}>
          <img
            src='delray/delray.png'
            className={ `${styles.productImg} ${delrayGrow ? styles.imgMoving : ''}` }
          />
          <div className={delrayGrow ? `${styles.hidden} ` : styles.productName }> Coco Delray </div>
        </div>

        <div className={ `${styles.card} ${rallyGrow ? styles.rallyMoving : ''} ${delrayGrow ? styles.rallyHiding : ''}`  } onClick={onClickRally}>
          <img
            src='rally/rally.png'
            className={ `${styles.productImg} ${ rallyGrow ? styles.imgMoving : ''}` }
          />
          <div className={rallyGrow ? `${styles.hidden} ` : styles.productName }> Fresh Foam X CT-Rally </div>
        </div>

      </div>
    </div>
  );
};

export default ProductPoll; 